// Brand / firm copy (8 languages). Proper nouns (Alvin Kumar & Associates, FRCS, akfiji.com, Nadi) stay untranslated.
export const brand = {
  en: {
    tagline: "Business Advisory & Compliance Division",
    navTax: "Tax Services",
    review: "Leave us a review",
    testimonials: { overline: "What clients say", title: "Trusted by investors and local businesses across Fiji." },
    form: { title: "You've got the overview. Get the current fees, the full document checklist, and direct answers from a licensed Fiji advisor — free.", sub: "AI answers go stale. Ours are reviewed monthly and come with a real person to call.", submit: "Email Me the Full Guide" },
    about: {
      overline: "About the firm",
      title: "A Nadi-based accounting and tax practice, serving all of Fiji.",
      p1: "Alvin Kumar & Associates is a Nadi-based accounting and tax practice led by Alvin Kumar (Principal, FRCS Registered Tax Agent No. 1065). Our business advisory and compliance division — the team behind this site — serves local businesses, foreign investors and individuals across Fiji.",
      p2: "From company formation and investor permits to tax registration, FRCS compliance and business banking, all engagements are carried out and invoiced by Alvin Kumar & Associates under our Master Terms of Business.",
      principal: "Principal",
      registration: "Registration",
      office: "Registered office",
      hours: "Office hours",
    },
    taxBanner: {
      overline: "Tax queries?",
      title: "Have a tax question?",
      body: "Visit our tax website for income tax returns, VAT, PAYE, FNPF, FNU levy, CGT, tax clearance and FRCS compliance support.",
      button: "Visit akfiji.com",
    },
    contactNote: "For tax-related queries, you can also visit",
    engagement: "All engagements are carried out and invoiced by Alvin Kumar & Associates under our Master Terms of Business.",
    footer: {
      email: "Email",
      address: "Registered office",
      hours: "Office hours",
      taxQueries: "Tax queries: visit akfiji.com",
      legal: "Alvin Kumar & Associates — Business Advisory & Compliance | FRCS Registered Tax Agent No. 1065",
    },
    locations: { registered: "Registered office", byAppointment: "Meetings by appointment" },
    termsEngagement: { h: "Engagements", body: "All engagements are carried out and invoiced by Alvin Kumar & Associates under our Master Terms of Business. Alvin Kumar & Associates (trading as AK Fiji) is the entity responsible for this website." },
  },
  zh: {
    tagline: "商业咨询与合规部门",
    navTax: "税务服务",
    review: "给我们留下评价",
    testimonials: { overline: "客户评价", title: "深受斐济各地投资者与本地企业信赖。" },
    form: { title: "您已了解概况。免费获取最新费用、完整文件清单，以及来自持牌斐济顾问的直接解答。", sub: "AI 的答案会过时。我们的内容每月审核更新，并且有真人可以联系。", submit: "把完整指南发到我的邮箱" },
    about: {
      overline: "关于我们",
      title: "立足楠迪、服务全斐济的会计与税务事务所。",
      p1: "Alvin Kumar & Associates 是一家位于楠迪的会计与税务事务所，由 Alvin Kumar（主理人，FRCS 注册税务代理人编号 1065）领导。本网站由我们的商业咨询与合规部门运营，为斐济各地的本地企业、外国投资者和个人提供服务。",
      p2: "从公司设立、投资者许可到税务登记、FRCS 合规和企业银行开户，所有业务均由 Alvin Kumar & Associates 根据我们的《业务主条款》执行并开具发票。",
      principal: "主理人",
      registration: "注册资质",
      office: "注册办公地址",
      hours: "办公时间",
    },
    taxBanner: {
      overline: "税务问题？",
      title: "有税务方面的问题？",
      body: "请访问我们的税务网站，获取所得税申报、VAT、PAYE、FNPF、FNU 税费、CGT、税务清税及 FRCS 合规支持。",
      button: "访问 akfiji.com",
    },
    contactNote: "如有税务相关问题，您也可以访问",
    engagement: "所有业务均由 Alvin Kumar & Associates 根据我们的《业务主条款》执行并开具发票。",
    footer: {
      email: "电子邮箱",
      address: "注册办公地址",
      hours: "办公时间",
      taxQueries: "税务问题：请访问 akfiji.com",
      legal: "Alvin Kumar & Associates — 商业咨询与合规 | FRCS 注册税务代理人编号 1065",
    },
    locations: { registered: "注册办公地址", byAppointment: "预约会面" },
    termsEngagement: { h: "业务委托", body: "所有业务均由 Alvin Kumar & Associates 根据我们的《业务主条款》执行并开具发票。Alvin Kumar & Associates（以 AK Fiji 名义经营）是本网站的责任主体。" },
  },
  hi: {
    tagline: "बिज़नेस एडवाइज़री एवं कंप्लायंस डिवीज़न",
    navTax: "टैक्स सेवाएँ",
    review: "हमें रिव्यू दें",
    testimonials: { overline: "क्लाइंट क्या कहते हैं", title: "पूरे फ़िजी के निवेशकों और स्थानीय व्यवसायों का भरोसा।" },
    form: { title: "आपको अवलोकन मिल गया है। अब मौजूदा फीस, पूरी दस्तावेज़ चेकलिस्ट और लाइसेंस प्राप्त फ़िजी सलाहकार से सीधे उत्तर पाएँ — निःशुल्क।", sub: "AI के उत्तर पुराने पड़ जाते हैं। हमारे उत्तर हर महीने समीक्षित होते हैं और साथ में एक वास्तविक व्यक्ति होता है जिसे आप कॉल कर सकते हैं।", submit: "मुझे पूरी गाइड ईमेल करें" },
    about: {
      overline: "फर्म के बारे में",
      title: "नाडी स्थित अकाउंटिंग और टैक्स प्रैक्टिस, पूरे फ़िजी की सेवा में।",
      p1: "Alvin Kumar & Associates नाडी स्थित एक अकाउंटिंग और टैक्स प्रैक्टिस है, जिसका नेतृत्व Alvin Kumar (प्रिंसिपल, FRCS पंजीकृत टैक्स एजेंट नं. 1065) करते हैं। हमारा बिज़नेस एडवाइज़री और कंप्लायंस डिवीज़न — इस साइट के पीछे की टीम — पूरे फ़िजी में स्थानीय व्यवसायों, विदेशी निवेशकों और व्यक्तियों की सेवा करता है।",
      p2: "कंपनी गठन और निवेशक परमिट से लेकर टैक्स पंजीकरण, FRCS अनुपालन और बिज़नेस बैंकिंग तक, सभी कार्य Alvin Kumar & Associates द्वारा हमारी मास्टर टर्म्स ऑफ़ बिज़नेस के अंतर्गत किए और इनवॉइस किए जाते हैं।",
      principal: "प्रिंसिपल",
      registration: "पंजीकरण",
      office: "पंजीकृत कार्यालय",
      hours: "कार्यालय समय",
    },
    taxBanner: {
      overline: "टैक्स से जुड़े प्रश्न?",
      title: "कोई टैक्स प्रश्न है?",
      body: "इनकम टैक्स रिटर्न, VAT, PAYE, FNPF, FNU लेवी, CGT, टैक्स क्लियरेंस और FRCS अनुपालन सहायता के लिए हमारी टैक्स वेबसाइट देखें।",
      button: "akfiji.com देखें",
    },
    contactNote: "टैक्स से संबंधित प्रश्नों के लिए आप यहाँ भी जा सकते हैं",
    engagement: "सभी कार्य Alvin Kumar & Associates द्वारा हमारी मास्टर टर्म्स ऑफ़ बिज़नेस के अंतर्गत किए और इनवॉइस किए जाते हैं।",
    footer: {
      email: "ईमेल",
      address: "पंजीकृत कार्यालय",
      hours: "कार्यालय समय",
      taxQueries: "टैक्स प्रश्न: akfiji.com देखें",
      legal: "Alvin Kumar & Associates — बिज़नेस एडवाइज़री एवं कंप्लायंस | FRCS पंजीकृत टैक्स एजेंट नं. 1065",
    },
    locations: { registered: "पंजीकृत कार्यालय", byAppointment: "अपॉइंटमेंट पर बैठकें" },
    termsEngagement: { h: "कार्य-संलग्नता", body: "सभी कार्य Alvin Kumar & Associates द्वारा हमारी मास्टर टर्म्स ऑफ़ बिज़नेस के अंतर्गत किए और इनवॉइस किए जाते हैं। Alvin Kumar & Associates (AK Fiji के नाम से व्यापार करते हुए) इस वेबसाइट के लिए उत्तरदायी संस्था है।" },
  },
  ja: {
    tagline: "ビジネスアドバイザリー＆コンプライアンス部門",
    navTax: "税務サービス",
    review: "レビューを書く",
    testimonials: { overline: "お客様の声", title: "フィジー全土の投資家と地元企業から信頼されています。" },
    form: { title: "概要はご確認いただけました。最新の費用、必要書類の完全チェックリスト、そしてフィジーの登録アドバイザーからの直接回答を無料でお届けします。", sub: "AIの回答は古くなります。当事務所の情報は毎月見直され、実際に電話できる担当者がつきます。", submit: "完全ガイドをメールで受け取る" },
    about: {
      overline: "事務所について",
      title: "ナンディを拠点に、フィジー全土に対応する会計・税務事務所。",
      p1: "Alvin Kumar & Associatesは、Alvin Kumar（代表、FRCS登録税務代理人 No. 1065）が率いるナンディ拠点の会計・税務事務所です。本サイトを運営するビジネスアドバイザリー＆コンプライアンス部門は、フィジー全土の地元企業、外国投資家、個人のお客様をサポートしています。",
      p2: "会社設立や投資家許可から税務登録、FRCSコンプライアンス、法人口座開設まで、すべての業務はAlvin Kumar & Associatesが当事務所の基本業務約款（Master Terms of Business）に基づいて実施・請求します。",
      principal: "代表",
      registration: "登録",
      office: "登録事務所",
      hours: "営業時間",
    },
    taxBanner: {
      overline: "税務のご質問は？",
      title: "税務に関するご質問はありますか？",
      body: "所得税申告、VAT、PAYE、FNPF、FNU levy、CGT、タックスクリアランス、FRCSコンプライアンス支援については、税務専門サイトをご覧ください。",
      button: "akfiji.com を見る",
    },
    contactNote: "税務関連のご質問は、こちらもご覧ください：",
    engagement: "すべての業務はAlvin Kumar & Associatesが基本業務約款（Master Terms of Business）に基づいて実施・請求します。",
    footer: {
      email: "メール",
      address: "登録事務所",
      hours: "営業時間",
      taxQueries: "税務のご質問：akfiji.com へ",
      legal: "Alvin Kumar & Associates — ビジネスアドバイザリー＆コンプライアンス | FRCS登録税務代理人 No. 1065",
    },
    locations: { registered: "登録事務所", byAppointment: "面談は要予約" },
    termsEngagement: { h: "業務の実施", body: "すべての業務はAlvin Kumar & Associatesが基本業務約款（Master Terms of Business）に基づいて実施・請求します。Alvin Kumar & Associates（AK Fijiとして営業）が本ウェブサイトの責任主体です。" },
  },
  ko: {
    tagline: "비즈니스 자문 및 컴플라이언스 부문",
    navTax: "세무 서비스",
    review: "리뷰 남기기",
    testimonials: { overline: "고객 후기", title: "피지 전역의 투자자와 현지 기업이 신뢰합니다." },
    form: { title: "개요는 확인하셨습니다. 최신 수수료, 전체 서류 체크리스트, 그리고 피지 등록 자문가의 직접 답변을 무료로 받아보세요.", sub: "AI 답변은 금방 낡습니다. 저희 정보는 매월 검토되며 실제로 통화할 수 있는 담당자가 있습니다.", submit: "전체 가이드 이메일로 받기" },
    about: {
      overline: "회사 소개",
      title: "난디에 기반을 두고 피지 전역을 지원하는 회계·세무 법인.",
      p1: "Alvin Kumar & Associates는 Alvin Kumar(대표, FRCS 등록 세무대리인 No. 1065)가 이끄는 난디 기반의 회계·세무 법인입니다. 이 사이트를 운영하는 비즈니스 자문 및 컴플라이언스 부문은 피지 전역의 현지 기업, 외국인 투자자 및 개인을 지원합니다.",
      p2: "회사 설립과 투자자 허가부터 세무 등록, FRCS 컴플라이언스, 기업 은행 계좌 개설까지 모든 업무는 Alvin Kumar & Associates가 당사의 기본 업무 약관(Master Terms of Business)에 따라 수행하고 청구합니다.",
      principal: "대표",
      registration: "등록",
      office: "등록 사무소",
      hours: "업무 시간",
    },
    taxBanner: {
      overline: "세무 문의?",
      title: "세무 관련 질문이 있으신가요?",
      body: "소득세 신고, VAT, PAYE, FNPF, FNU levy, CGT, 납세 증명 및 FRCS 컴플라이언스 지원은 당사의 세무 전용 웹사이트를 방문하세요.",
      button: "akfiji.com 방문",
    },
    contactNote: "세무 관련 문의는 다음 사이트도 이용하실 수 있습니다:",
    engagement: "모든 업무는 Alvin Kumar & Associates가 기본 업무 약관(Master Terms of Business)에 따라 수행하고 청구합니다.",
    footer: {
      email: "이메일",
      address: "등록 사무소",
      hours: "업무 시간",
      taxQueries: "세무 문의: akfiji.com 방문",
      legal: "Alvin Kumar & Associates — 비즈니스 자문 및 컴플라이언스 | FRCS 등록 세무대리인 No. 1065",
    },
    locations: { registered: "등록 사무소", byAppointment: "예약제 미팅" },
    termsEngagement: { h: "업무 수행", body: "모든 업무는 Alvin Kumar & Associates가 기본 업무 약관(Master Terms of Business)에 따라 수행하고 청구합니다. Alvin Kumar & Associates(AK Fiji로 영업)가 본 웹사이트의 책임 주체입니다." },
  },
  es: {
    tagline: "División de Asesoría Empresarial y Cumplimiento",
    navTax: "Servicios fiscales",
    review: "Déjenos una reseña",
    testimonials: { overline: "Lo que dicen nuestros clientes", title: "La confianza de inversores y empresas locales en todo Fiyi." },
    form: { title: "Ya tiene la visión general. Obtenga las tarifas actuales, la lista completa de documentos y respuestas directas de un asesor autorizado en Fiyi — gratis.", sub: "Las respuestas de la IA se quedan obsoletas. Las nuestras se revisan cada mes y vienen con una persona real a la que llamar.", submit: "Envíenme la guía completa por correo" },
    about: {
      overline: "Sobre la firma",
      title: "Una firma contable y fiscal con sede en Nadi, al servicio de todo Fiyi.",
      p1: "Alvin Kumar & Associates es una firma contable y fiscal con sede en Nadi, dirigida por Alvin Kumar (Socio principal, Agente Fiscal Registrado FRCS n.º 1065). Nuestra división de asesoría empresarial y cumplimiento — el equipo detrás de este sitio — atiende a empresas locales, inversores extranjeros y particulares en todo Fiyi.",
      p2: "Desde la constitución de sociedades y los permisos de inversor hasta el registro fiscal, el cumplimiento ante la FRCS y la banca empresarial, todos los encargos son ejecutados y facturados por Alvin Kumar & Associates conforme a nuestros Términos Generales de Negocio.",
      principal: "Socio principal",
      registration: "Registro",
      office: "Domicilio registrado",
      hours: "Horario de oficina",
    },
    taxBanner: {
      overline: "¿Consultas fiscales?",
      title: "¿Tiene una pregunta fiscal?",
      body: "Visite nuestro sitio web fiscal para declaraciones de impuesto sobre la renta, VAT, PAYE, FNPF, FNU levy, CGT, certificados de cumplimiento fiscal y soporte de cumplimiento ante la FRCS.",
      button: "Visitar akfiji.com",
    },
    contactNote: "Para consultas fiscales, también puede visitar",
    engagement: "Todos los encargos son ejecutados y facturados por Alvin Kumar & Associates conforme a nuestros Términos Generales de Negocio.",
    footer: {
      email: "Correo electrónico",
      address: "Domicilio registrado",
      hours: "Horario de oficina",
      taxQueries: "Consultas fiscales: visite akfiji.com",
      legal: "Alvin Kumar & Associates — Asesoría Empresarial y Cumplimiento | Agente Fiscal Registrado FRCS n.º 1065",
    },
    locations: { registered: "Domicilio registrado", byAppointment: "Reuniones con cita previa" },
    termsEngagement: { h: "Encargos", body: "Todos los encargos son ejecutados y facturados por Alvin Kumar & Associates conforme a nuestros Términos Generales de Negocio. Alvin Kumar & Associates (operando como AK Fiji) es la entidad responsable de este sitio web." },
  },
  fr: {
    tagline: "Division Conseil aux Entreprises & Conformité",
    navTax: "Services fiscaux",
    review: "Laissez-nous un avis",
    testimonials: { overline: "Ce que disent nos clients", title: "La confiance des investisseurs et des entreprises locales à travers les Fidji." },
    form: { title: "Vous avez la vue d'ensemble. Obtenez les frais actuels, la liste complète des documents et des réponses directes d'un conseiller agréé aux Fidji — gratuitement.", sub: "Les réponses des IA se périment. Les nôtres sont revues chaque mois et s'accompagnent d'une vraie personne à appeler.", submit: "Recevoir le guide complet par e-mail" },
    about: {
      overline: "À propos du cabinet",
      title: "Un cabinet comptable et fiscal basé à Nadi, au service de toutes les Fidji.",
      p1: "Alvin Kumar & Associates est un cabinet comptable et fiscal basé à Nadi, dirigé par Alvin Kumar (Associé principal, Agent fiscal enregistré FRCS n° 1065). Notre division conseil aux entreprises et conformité — l'équipe derrière ce site — accompagne les entreprises locales, les investisseurs étrangers et les particuliers dans toutes les Fidji.",
      p2: "De la création de société et des permis d'investisseur à l'enregistrement fiscal, à la conformité FRCS et à la banque professionnelle, toutes les missions sont réalisées et facturées par Alvin Kumar & Associates selon nos Conditions générales d'affaires.",
      principal: "Associé principal",
      registration: "Enregistrement",
      office: "Siège social",
      hours: "Horaires du bureau",
    },
    taxBanner: {
      overline: "Questions fiscales ?",
      title: "Vous avez une question fiscale ?",
      body: "Consultez notre site fiscal pour les déclarations d'impôt sur le revenu, la VAT, le PAYE, le FNPF, la FNU levy, la CGT, les attestations fiscales et l'accompagnement à la conformité FRCS.",
      button: "Visiter akfiji.com",
    },
    contactNote: "Pour les questions fiscales, vous pouvez aussi consulter",
    engagement: "Toutes les missions sont réalisées et facturées par Alvin Kumar & Associates selon nos Conditions générales d'affaires.",
    footer: {
      email: "E-mail",
      address: "Siège social",
      hours: "Horaires du bureau",
      taxQueries: "Questions fiscales : visitez akfiji.com",
      legal: "Alvin Kumar & Associates — Conseil aux Entreprises & Conformité | Agent fiscal enregistré FRCS n° 1065",
    },
    locations: { registered: "Siège social", byAppointment: "Rendez-vous sur demande" },
    termsEngagement: { h: "Missions", body: "Toutes les missions sont réalisées et facturées par Alvin Kumar & Associates selon nos Conditions générales d'affaires. Alvin Kumar & Associates (exerçant sous le nom AK Fiji) est l'entité responsable de ce site web." },
  },
  ar: {
    tagline: "قسم الاستشارات التجارية والامتثال",
    navTax: "الخدمات الضريبية",
    review: "اترك لنا تقييماً",
    testimonials: { overline: "ماذا يقول عملاؤنا", title: "موثوقون من المستثمرين والشركات المحلية في جميع أنحاء فيجي." },
    form: { title: "لقد حصلت على النظرة العامة. احصل مجاناً على الرسوم الحالية وقائمة المستندات الكاملة وإجابات مباشرة من مستشار مرخّص في فيجي.", sub: "إجابات الذكاء الاصطناعي تصبح قديمة. إجاباتنا تُراجَع شهرياً ويرافقها شخص حقيقي يمكنك الاتصال به.", submit: "أرسلوا لي الدليل الكامل بالبريد" },
    about: {
      overline: "عن الشركة",
      title: "مكتب محاسبة وضرائب مقره نادي، يخدم فيجي بأكملها.",
      p1: "Alvin Kumar & Associates مكتب محاسبة وضرائب مقره نادي، يقوده Alvin Kumar (الشريك الرئيسي، وكيل ضرائب مسجّل لدى FRCS رقم 1065). يخدم قسم الاستشارات التجارية والامتثال لدينا — الفريق الذي يقف خلف هذا الموقع — الشركات المحلية والمستثمرين الأجانب والأفراد في جميع أنحاء فيجي.",
      p2: "من تأسيس الشركات وتصاريح المستثمرين إلى التسجيل الضريبي والامتثال لـ FRCS والخدمات البنكية للشركات، تُنفَّذ جميع المهام وتُصدَر فواتيرها من قِبل Alvin Kumar & Associates بموجب الشروط العامة للأعمال لدينا.",
      principal: "الشريك الرئيسي",
      registration: "التسجيل",
      office: "المكتب المسجّل",
      hours: "ساعات العمل",
    },
    taxBanner: {
      overline: "استفسارات ضريبية؟",
      title: "هل لديك سؤال ضريبي؟",
      body: "تفضّل بزيارة موقعنا الضريبي للحصول على الدعم في إقرارات ضريبة الدخل وVAT وPAYE وFNPF ورسم FNU وCGT وشهادات التخليص الضريبي والامتثال لـ FRCS.",
      button: "زيارة akfiji.com",
    },
    contactNote: "للاستفسارات الضريبية، يمكنك أيضاً زيارة",
    engagement: "تُنفَّذ جميع المهام وتُصدَر فواتيرها من قِبل Alvin Kumar & Associates بموجب الشروط العامة للأعمال لدينا.",
    footer: {
      email: "البريد الإلكتروني",
      address: "المكتب المسجّل",
      hours: "ساعات العمل",
      taxQueries: "استفسارات ضريبية: زوروا akfiji.com",
      legal: "Alvin Kumar & Associates — الاستشارات التجارية والامتثال | وكيل ضرائب مسجّل لدى FRCS رقم 1065",
    },
    locations: { registered: "المكتب المسجّل", byAppointment: "اللقاءات بموعد مسبق" },
    termsEngagement: { h: "المهام", body: "تُنفَّذ جميع المهام وتُصدَر فواتيرها من قِبل Alvin Kumar & Associates بموجب الشروط العامة للأعمال لدينا. Alvin Kumar & Associates (التي تعمل باسم AK Fiji) هي الجهة المسؤولة عن هذا الموقع." },
  },
};
